import React, { useState, useEffect, useRef, useCallback } from 'react'

import {
    Box,
    // Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    Stack,
    FormHelperText,
    ListItemButton,
    List,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Chip,
    Checkbox,
    ListItem,
} from '@mui/material';

import * as Yup from "yup";

import { grey } from '@mui/material/colors';

// import { useNavigate, Link } from 'react-router-dom';

// import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
// import { icons } from '../../common/CommonIcons';
// import CommonBreadcumbs from '../../common/CommonBreadcumbs';
// import CommonRestricted from '../../common/CommonRestricted';
// import DataGridTable from '../../common/DataGridTable';
// import DataGridToolbar from '../../common/DataGridToolbar';

// import { useDataGridParams } from '../../../hooks/useDataGridParams';
// import { useAppContextFeatures } from '../../../context/AppContext';
// import { useDocuments, documentTypes, targetTypes } from '../../../hooks/api/useDocuments';
// import { useSystemPrompt } from '../../../hooks/useSystemPrompt'
// import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
// import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
// import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import { useFormik } from 'formik';

import { CommonIcons, icons } from "../../common/CommonIcons";

// import { validationSchema, initialValues, initialRowValues, initialRowInventoryValues, initialRowTransformIntoValues } from "../../../schema/documents/itemTransformSchema"

import { checkValueExists } from "../../../utils/dataSchema"

import { useStateInventoryBatches } from "../../../hooks/state/useStateInventoryBatches";
import { useTranslations } from '../../../hooks/useTranslations';

const StyledCard2 = styled(Card)(({ theme }) => ({
    padding: theme.spacing(0)
}));

export const validateRowSchema = Yup.object().shape({
    batchId: Yup
        .string(),
    slotId: Yup
        .string(),
    qty: Yup.lazy((val) => {

        let maxQty = val?.maxQty ? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid"),
        })

    })
})

export const validationSchema = Yup.object({
    itemId: Yup
        .string()
        .required("Required"),
    rows: Yup.array().of(validateRowSchema)
})

export const initialRowValues = {
    batchId: "",
    slotId: "",
    customBatchNo: "",
    expiryDate: "",
    qty: {
        value: "",
        maxQty: 0,
    },
    label: ""
}

export const initialValues = {
    itemId: "",
    rows: [],
}


const StyledCard = styled(Card)(({ theme }) => ({
    // padding: theme.spacing(4)
}));

export default function SelectInventory({
    routeType,
    locationId,
    selectedInventory,
    rowIndex,
    productId,
    itemId,
    handleOnConfirm
}) {

    const { t } = useTranslations({ ns: ["common", "@document"] })

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (values) => {

            // console.log('values', values)
            handleOnConfirm({
                productId,
                rowIndex,
                values
            })

        }
    });

    const {
        values,
        errors,
        touched,
        handleSubmit,
        handleChange,
        setFieldValue
    } = formik

    const {
        isLoading: isLoadingInventoryBatches,
        skipBatchId,
        // skipIndexNoArray,
        dataInventoryBatches,
        resetDataInventoryBatches,
        selectInventoryBatch,
        getInventoryBatchesByItemId,
        getSelectedInventoryBatch,
        appendInventoryBatch,
        removeAllSelectedIndexNo,
        deselectByBatchIds,
        RenderValueComponent,
        RenderSubHeaderComponent,
        RenderMenuItemComponent,
        RenderDisplayText
    } = useStateInventoryBatches({
        // multiple: true 
        locationId
    })

    useEffect(() => {

        appendInventoryBatch({ itemId, selectedIndexNo: 0 })

        setFieldValue(`itemId`, itemId)

    }, [])

    useEffect(() => {

        let preloadRows = []

        // console.log('selectedInventory ->>', selectedInventory)

        // preselect the request selection
        selectedInventory.forEach(e1 => {

            let e1BatchId = e1.batchId
            let e1Qty = e1.qty

            const selectedBatch = selectInventoryBatch({
                itemId,
                batchId: e1BatchId,
                selectedIndexNo: 0
            })

            // console.log('selectedBatch', selectedBatch)

            preloadRows.push({
                batchId: e1BatchId,
                qty: e1Qty,
                label: selectedBatch.label
            })

        })

        setFieldValue(
            `rows`,
            preloadRows
        )

    }, [dataInventoryBatches])

    const handleRemoveRow = ({ index }) => {
        setFieldValue(`rows`, values.rows.filter((i, ind) => ind !== index))
    }

    // able to filter out the inventory batches been selected even for the same uom id
    const getAvailableInventoryBatches = (
        { index, itemId }
    ) => {

        const selected = getInventoryBatchesByItemId({ itemId, selectedIndexNo: index })

        // remove the selection if the index selected
        const showSelected = selected.filter(i => i.selectedIndexNo === false || i.selectedIndexNo === index)

        return showSelected;
    }

    const RenderInventoryBatchRow = (
        { index, item }
        // { index, index2, item, itemTouched, itemErrors, itemValuesInventory }
    ) => {

        let itemValues = values.rows[index]
        let itemInventoryTouched = touched.rows
        let itemInventoryErrors = errors.rows

        if (itemInventoryTouched) {
            itemInventoryTouched = (itemInventoryTouched[index] !== undefined) ? itemInventoryTouched[index] : {};
        }

        if (itemInventoryErrors) {
            itemInventoryErrors = (itemInventoryErrors[index] !== undefined) ? itemInventoryErrors[index] : {};
        }

        if (!itemValues?.label) return <></>

        return (
            <ListItem
                key={index}
                disableGutters
                disablePadding
                divider
                sx={{
                    pl: 2
                }}
            >
                <Grid item xs={12}>
                    {/* {JSON.stringify(itemValues)} */}
                    <Grid container spacing={1}>
                        <Grid item xs={8} display={"flex"} justifyContent={"flex-start"} alignItems={"center"} flexWrap={1}>
                            <Typography sx={{ fontSize: 13 }}>{item.label}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                // inputProps={{
                                //     style: {
                                //         textAlign: "center"
                                //     }
                                // }}
                                margin="dense"
                                size="small"
                                fullWidth
                                name={`rows.${index}.qty`}
                                label={t(`qty`)}
                                type="text"
                                variant="outlined"
                                value={itemValues?.qty?.value ? itemValues.qty.value : "0"}
                                onChange={(event) => {

                                    let val = event.target.value

                                    setFieldValue(
                                        `rows.${index}.qty`,
                                        {
                                            ...itemValues.qty,
                                            value: val
                                        }
                                    )

                                    // setTimeout(() => {
                                    //     updateStateTransformIntoTotalQty({ index })
                                    // }, 500)

                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            / {parseFloat(item?.qty?.maxQty)}
                                        </InputAdornment>
                                    )
                                }}
                                onFocus={event => {
                                    event.target.select();
                                }}
                                error={Boolean(itemInventoryErrors?.qty?.value)}
                                helperText={itemInventoryErrors?.qty?.value}
                            />
                        </Grid>
                        <Grid item xs={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <IconButton
                                size="small"
                                onClick={() => {
                                    handleRemoveRow({ index })
                                }}
                            >
                                <CommonIcons name={icons.cross} />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItem>
        )
    }

    const RenderInventorySelect = (
        // { item, index, itemErrors, itemTouched, itemValues }
    ) => {

        let valueRows = values.rows

        let index = 0;

        if (isLoadingInventoryBatches) {

            return (
                <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    placeholder="Loading..."
                    type="text"
                    variant="outlined"
                />
            )

        }

        return (
            <FormControl
                margin="dense"
                fullWidth
                size="small"
            // error={Boolean(itemErrors?.inventoryBatchId)}
            >
                {/* <Typography sx={{ fontSize: 10 }}>
                    {JSON.stringify(values.rows)}
                </Typography> */}
                <InputLabel id="inventory">{t('availableInventory')}</InputLabel>
                <Select
                    // disabled={
                    //     !(itemValues?.itemId)
                    // }
                    labelId="inventory"
                    label={t('availableInventory')}
                    name={`rows`}
                    // onChange={handleChange}
                    onChange={(event) => {

                        let batchId = event.target.value

                        // console.log('batchId', batchId)

                        // // check the batch is selected
                        const checkDup = valueRows.filter(i => i.batchId === batchId)

                        // console.log('checkDup', checkDup)

                        if (checkDup.length <= 0) {

                            const selectedBatch = selectInventoryBatch({
                                itemId,
                                // itemId: itemValues.itemId,
                                batchId,
                                selectedIndexNo: 0
                            })

                            console.log('selectedBatch', selectedBatch)

                            setFieldValue(
                                `rows`,
                                values.rows.concat({
                                    batchId,
                                    slotId: selectedBatch?.slotId,
                                    customBatchNo: selectedBatch?.customBatchNo,
                                    expiryDate: selectedBatch?.expiryDate,
                                    qty: {
                                        value: "0",
                                        maxQty: selectedBatch?.totalRemainQty
                                    },
                                    label: selectedBatch.label
                                })
                            )
                        }

                    }}
                    value={
                        valueRows.length ? valueRows[0].batchId : ""
                    }
                    renderValue={(props) => {
                        return (
                            <Chip
                                label={`${valueRows.length} Selected`}
                                size="small"
                            />
                        )
                    }}
                    sx={{
                        textAlign: 'left'
                    }}
                    MenuProps={{
                        MenuListProps: {
                            sx: {
                                py: 0
                            },
                        }
                    }}
                // multiple
                >
                    <RenderSubHeaderComponent
                        itemId={itemId}
                        index={index}
                    // enableMultipleSelection={Boolean(true)}
                    />
                    {/* <MenuItem id={""}><></></MenuItem> */}
                    {
                        getAvailableInventoryBatches(
                            { index, itemId }
                        ).map((item, index) => {

                            // console.log('itemValues.inventory', itemValues.inventory, item)

                            const isExist = valueRows.filter(i => i.batchId === item.batchId)

                            // console.log('isE', isExist, item.batchId)

                            return (
                                RenderMenuItemComponent({
                                    key: index,
                                    index,
                                    item,
                                    selected: isExist.length > 0,
                                    // enableMultipleSelection: true,
                                    style: {
                                        width: 600
                                    }
                                })

                            )
                        })
                    }
                </Select>
            </FormControl>
        )
    }

    const RenderSelectionEmpty = () => {
        return (
            <StyledCard2
                sx={{
                    backgroundColor: grey[100]
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 200,
                    }}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Typography
                        sx={{
                            fontSize: 14
                        }}
                    >
                        {t('youHaveNotSelectAnyInventoryYet')}
                    </Typography>
                </Box>
            </StyledCard2>
        )
    }

    const RenderSelection = () => {

        if (values.rows.length <= 0) {
            return <RenderSelectionEmpty />
        }

        return (
            <StyledCard2>
                <Grid container spacing={0}>
                    {
                        values.rows.map((i2, index2) => {
                            return RenderInventoryBatchRow({
                                index: index2,
                                item: i2
                            })
                        })
                    }
                </Grid>
            </StyledCard2>
        )
    }

    return (
        <Box
            sx={{
                p: 2
            }}
        >

            {/* {
                JSON.stringify(values)
            }
            {
                JSON.stringify(errors)
            } */}
            {/* <RenderSectionDivider title={`Consumption (${itemValues?.uomName})`} /> */}

            {
                RenderInventorySelect()
            }

            <form onSubmit={handleSubmit}>

                {
                    RenderSelection()
                }

                <Button
                    variant='contained'
                    type='submit'
                    fullWidth
                    sx={{
                        mt: 1
                    }}
                >
                    {t('confirm')}
                </Button>
            </form>

        </Box>
    )
}
